import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { StockSalesOrderApprovalResponseModel } from '~/models/administration/stockSalesOrderApprovalResponseModel';
import { StockSalesOrderApprovalsWithUser } from '~/models/administration/stockSalesOrderApprovals';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class SOApprovalsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }


    
    getSalesOrderApprovalGrid(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
          .post<StockSalesOrderApprovalResponseModel[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
          })
          .pipe(map(augmentPaging));
    }     

    getStockSalesOrderApproval() {
        return this.http.get<StockSalesOrderApprovalsWithUser>(this._url());
    }

    getStockSalesOrderApprovalById(id: number) {
        return this.http.get<StockSalesOrderApprovalsWithUser>(`${this._url()}/${id}`);
    }

    updateStockSalesOrderApproval(model: any, id: number) {
        return this.client.put(`${this._url()}/${id}`, model);
    }

    createStockSalesOrderApproval(model: any) {
        return this.client.post(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/StockSalesOrderApprovals${v}`);
    }
}
